import React, { useState, useContext, useRef } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import moment from "moment/moment";
import Company_invoice_item_ledger_modal from "./company_invoice_item_ledger_modal";

const Company_invoice_ledger_table = ({invoice}) => {
    const [invoice_detail, setinvoice_detail] = useState({});
    const [show, setshow] = useState(false);
  return (
    <div>
        <Company_invoice_item_ledger_modal show={show} setshow={setshow} invoice_detail={invoice_detail}/>
        {/* Expense List Card */}
        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto"> 
            {/* Section Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                <h2 className="text-base font-semibold text-slate-800">لیستی وەسڵی کڕاو</h2>
            </div>

            {/* Table */}
            <table className="w-full">
                <thead>
                    <tr className="bg-slate-50 border-b border-slate-100">
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            کۆمپانیا
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            ژمارەی وەسڵ
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            جۆری وەسڵ
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            بەروار
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            نرخی ڕێنمینبی
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            خەرجی (CBI) بەرامبەر ۱م۳
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            کۆی نرخ
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            کۆی نرخ (دراوی بنچینەیی)
                        </th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-slate-50">
                {invoice?.map((lis, index) => (
                    <tr
                    key={index}
                    className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer"
                    onClick={() => {
                        // var temp_items=lis.items.map((item) => {
                        // return {
                        //     ...item,
                        //     item_unit_one_qty: (Number(item.item_qty)-Number(Math.floor(item.item_qty))) * Number(item.item_unit_one_of_many),
                        //     item_unit_many_qty: Math.floor(item.item_qty),
                        // }
                        // });
                        // var temp_invoice_detail = {
                        // ...lis,
                        // items: temp_items,
                        // };
                        setinvoice_detail(lis);
                        setshow(true);
                    }}
                    >
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.company_name}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.company_invoice_number}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.company_invoice_type=="cash"?"کاش":"قەرز"}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.company_invoice_date}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {numberbeautify(lis.company_invoice_rmb_price)}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {numberbeautify(lis.company_invoice_cbi_price)}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {numberbeautify(
                            money_rounding(
                            lis.items.reduce(
                            (sum, item) => sum + Number(item.company_invoice_item_price*(item.company_invoice_item_qty/item.item_unit_one_of_many)),
                            0
                            )
                            )
                        )} $
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {numberbeautify(
                            money_rounding(
                            lis.items.reduce(
                            (sum, item) => sum + Number(item.company_invoice_item_base_price*(item.company_invoice_item_qty/item.item_unit_one_of_many)),
                            0
                            )
                            )
                        )}
                    </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    </div>
  )
}

export default Company_invoice_ledger_table